import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { ICommission, ICommissionReport, IDailyCommission } from "./types/_commission";
const api = new APIClient();

const path = '/commission';
const path_ads_commission = '/ads/daily-report';
const commissionApi = {
  commissions(params: any): Promise<AxiosResponse<ResponseData<ICommission[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  commissionReports(params: any = {}): Promise<AxiosResponse<ResponseData<ICommissionReport>, any>> {
    const url = `/reports/media-daily`;//reports/commission
    return api.get(url, params)
  },
  dailyCommission(params: any = {}): Promise<AxiosResponse<ResponseData<IDailyCommission[]>, any>> {
    const url = `${path_ads_commission}`;
    return api.get(url, params)
  },
  getDailyCommission(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IDailyCommission>, any>> {
    const url = `${path_ads_commission}/${id}`;
    return api.get(url, params)
  },
  postDailyCommission(dataForm: any): Promise<AxiosResponse<ResponseData<IDailyCommission>, any>> {
    const url = `${path_ads_commission}`;
    return api.post(url, dataForm)
  },
  putDailyCommission(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IDailyCommission>, any>> {
    const url = `${path_ads_commission}/${id}`;
    return api.put(url, dataForm)
  },
  deleteDailyCommission(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IDailyCommission>, any>> {
    const url = `${path_ads_commission}/${id}`;
    return api.delete(url, dataForm)
  },
}
export default commissionApi
